var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "#1f2923",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 15.5C11.0001 15.7761 10.7762 16 10.5001 16C10.2239 16 10.0001 15.7761 10.0001 15.5L10.0001 5.71421L7.06074 8.65355C6.86547 8.84882 6.54889 8.84882 6.35363 8.65355C6.15837 8.45829 6.15837 8.14171 6.35363 7.94645L10.0999 4.20015C10.1284 4.16216 10.1622 4.12836 10.2002 4.09985L10.2427 4.05736C10.2456 4.06027 10.2485 4.0632 10.2514 4.06614C10.3246 4.02406 10.4095 4 10.5001 4C10.5906 4 10.6755 4.02406 10.7488 4.06614L10.7574 4.05736L10.7999 4.09986C10.8379 4.12837 10.8717 4.16216 10.9002 4.20014L14.6465 7.94645C14.8418 8.14171 14.8418 8.45829 14.6465 8.65355C14.4513 8.84882 14.1347 8.84882 13.9394 8.65355L11.0001 5.71421L11.0001 15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.6e8dda44d6e89d9eede0391033b47d44.svg";
export { ForwardRef as ReactComponent };